module.exports = __webpack_public_path__ + "static/media/img_2.e7563823.png";